module.exports = __webpack_public_path__ + "static/media/toiletChakudatsui.be06975b.png";